<template>
    <tr v-if="metroOptions.find(findByCity)">
        <dialog-metro
            ref="metroDialog"
            :checked-options="res"
            :metro-options="metroOptions"
            :city="p.city.name"
            @confirm="onConfirmMetros"
        />

        <td v-if="isEqual(o, n)" style="padding: 0 5px;"></td>
        <td v-else :class="{'selected': isEqual(o, res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(o)">
                <span class="comma">
                    <span v-for="(metro, index) in o" :key="index">
                        {{ metroOptions.find(item => item.value === metro).text }}
                    </span>
                </span>
                <i v-if="!o || (o.length === 0)">✕</i>
            </a>
        </td>

        <td :class="{'selected': !isEqual(o, n)}" style="padding: 0 5px;">
            <div class="textarea" @click.prevent.stop="editMetros">
            <span class="comma">
                <span v-for="(metro, index) in res" :key="index">
                    {{ metroOptions.find(item => item.value === metro).text }}
                </span>
            </span>
                <button type="button" class="tiny">Выбрать метро</button>
            </div>
        </td>

        <td v-if="isEqual(o, n)" style="padding: 0 5px;"></td>
        <td v-else :class="{'selected': isEqual(n, res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(n)">
                <span class="comma">
                    <span v-for="(metro, index) in n" :key="index">
                        {{ metroOptions.find(item => item.value === metro).text }}
                    </span>
                </span>
                <i v-if="!n || (n.length === 0)">✕</i>
            </a>
        </td>
    </tr>
</template>

<script>
import Base from "../Base.vue";
import DialogMetro from "../../../dialogs/common/clinics/MetroDialog";

export default {
    mixins: [Base],
    components: {
        DialogMetro,
    },
    props: {
        o: {
            type: Array,
            default: []
        },
        n: {
            type: Array,
            default: []
        },
        f: {
            type: Array,
            default: []
        },
        p: {
            type: Object,
            default: {},
        },
    },
    methods: {
        onConfirmMetros (checkedOptions) {
            this.cloneArrToRes(checkedOptions);
            this.$refs.metroDialog.$refs.dialog.hide();
        },
        editMetros () {
            this.$refs.metroDialog.$refs.dialog.show();
        },
        findByCity (item) {
            return item.city === this.p.city.name;
        },
    }
}
</script>
